import { JRCTypography } from 'components/JRCTypography/JRCTypography';
import * as React from 'react';
import styled from 'styled-components';
import { FormInputProps } from '../../Deprecated/JRCFormFieldRender';

const Container = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
`;

export const CheckboxWrapper = styled.div<{ disabled?: boolean }>`
    display: block;
    position: relative;
    padding-left: 24px;
    margin-bottom: 16px;
    cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
    user-select: none;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .checkbox-like {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        border-radius: 4px;
        background-color: ${(props) => (props.disabled ? props.theme.color.grey0 : props.theme.color.white)};
        border: 1px solid ${(props) => props.theme.color.grey3};
    }

    &:hover .checkbox-like {
        background-color: ${(props) => props.theme.color.grey0};
    }

    & input:checked ~ .checkbox-like {
        border: 1px solid ${(props) => (props.disabled ? props.theme.color.grey3 : props.theme.color.primaryD20)};
        background-color: ${(props) => (props.disabled ? props.theme.color.grey2 : props.theme.color.primary)};
    }

    .checkbox-like:after {
        content: '';
        position: absolute;
        display: none;
        left: 4px;
        top: 1.5px;
        width: 3px;
        height: 7px;
        border: solid white;
        border-width: 0 3px 3px 0;
        transform: rotate(40deg);
    }

    input:checked ~ span:after {
        display: block;
    }
`;
const Checkbox = function (props: FormInputProps, ref: React.ForwardedRef<HTMLInputElement>) {
    return (
        <Container>
            <CheckboxWrapper onClick={props.onClick} disabled={props.disabled}>
                <input {...props} type="checkbox" ref={ref}></input>
                {/* empty span for toggle styling */}
                <span className="checkbox-like"></span>
            </CheckboxWrapper>
            {props.title && <JRCTypography>{props.title}</JRCTypography>}
        </Container>
    );
};
export const JRCCheckbox = React.forwardRef(Checkbox);
